import { Search, Paintbrush, Eye, Package } from "lucide-react";

const steps = [
  { number: 1, title: "Search", description: "Find any address, city, or landmark in the world", Icon: Search },
  { number: 2, title: "Customize", description: "Choose palette, style, size, and frame to match your space", Icon: Paintbrush },
  { number: 3, title: "Preview", description: "See your custom 3D map rendered before ordering", Icon: Eye },
  { number: 4, title: "Receive", description: "3D printed and shipped to your door with care", Icon: Package },
];

const ProcessSteps = () => {
  return (
    <section className="py-24 px-6" style={{ backgroundColor: "var(--brand-bg)" }}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.2em] uppercase mb-3" style={{ color: "var(--sage-400)", fontFamily: "var(--font-body)" }}>
            The Process
          </p>
          <h2 className="text-4xl mb-4" style={{ fontFamily: "var(--font-heading)", color: "var(--brand-text)" }}>
            From Map to Masterpiece
          </h2>
          <p className="max-w-lg mx-auto" style={{ color: "var(--brand-muted)", fontWeight: 300, fontFamily: "var(--font-body)" }}>
            Four simple steps to transform any place in the world into collectible 3D art.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: "var(--sage-100)" }}>
                <step.Icon className="w-6 h-6" style={{ color: "var(--sage-400)" }} />
              </div>
              <div className="w-8 h-8 rounded-full flex items-center justify-center mx-auto mb-3 text-sm font-bold text-white" style={{ backgroundColor: "var(--sage-400)", fontFamily: "var(--font-body)" }}>
                {step.number}
              </div>
              <h3 className="text-base mb-2" style={{ fontFamily: "var(--font-heading)", color: "var(--brand-text)" }}>
                {step.title}
              </h3>
              <p className="text-sm" style={{ color: "var(--brand-muted)", fontWeight: 300, fontFamily: "var(--font-body)" }}>
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
